import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid} from '@mui/material';

import {LoadingContainer} from '../../../components/Loading/LoadingContainer';
import {ModulePageHeader} from '../../../components/ModulePageHeader/ModulePageHeader';
import {SnackBarContext} from '../../../contexts/SnackBarContext/SnackBarContext';
import {useUserData} from '../../../contexts/UserContext/useUserData';
import {CampaignsTable} from '../../../features/company/campaigns/CampaignsTable/CampaignsTable';
import {useApiRead} from '../../../hooks/useApiRead';
import {GetRoutes} from '../../../lib/api/GET/GetRoutes';
import {Campaign} from '../../../types/Campaign';
import {CompanyAdminRoleData} from '../../../types/User';

export const CampaignsPage = () => {
  const {t} = useTranslation();
  const {currentUser} = useUserData();
  const companyId = (currentUser?.role?.data as CompanyAdminRoleData)?.companyId;
  const {dispatchMessage} = useContext(SnackBarContext);

  const onError = () => {
    dispatchMessage('Could not fetch campaigns. Please contact support.', 'error');
  };

  const {data, isLoading} = useApiRead<Campaign[]>({
    path: GetRoutes.getCampaigns(companyId),
    options: {enabled: !!companyId},
    onError,
  });

  return (
    <Box sx={{maxWidth: 1120, mx: 'auto', width: '100%'}}>
      <ModulePageHeader
        moduleName={t('appHeader.moduleLabels.recruiting')}
        title={t('campaignsPage.header')}
      />
      <Grid width='100%' padding='30px' paddingBottom='52px' sx={{backgroundColor: '#fff', borderRadius: '16px'}}>
        {isLoading ? <LoadingContainer minHeight={'300px'} /> : <CampaignsTable campaigns={data || []} />}
      </Grid>
    </Box>
  );
};
